export default {
    GetDemeterCommentary: 'getDemeterCommentary',
    GetCurrencyConversionChart: 'getCurrencyConversionChart',
    GetDemeterCompany: 'getDemeterCompany',
    GetDemeterPrices: 'getDemeterPrices',
    GetDemeterProjection: 'getDemeterProjection',
    GetDemeterSeasonal: 'getDemeterSeasonal',
    GetUnitOfMeasureConversionChart: 'getUnitOfMeasureConversionChart',
    GetUserStore: 'getUserStore',
    GetDemeterOriginsOrDestinations: 'getDemeterOriginsDestinations',
    GetMarketIndicator: 'getMarketIndicator',
    GetMarketIndicatorFactor: 'getMarketIndicatorFactor',
    ListCalculationEngineInputsByGroup: 'ListCalculationEngineInputsByGroup',
    ListCalculationEngineResponse: 'ListCalculationEngineResponse',
    ListCommodityOtcPrices: 'listCommodityOtcPrices',
    ListCommodityOtcPricesCurrent: 'listCommodityOtcPricesCurrent',
    ListCommodityBasisPrices: 'listCommodityBasisPrices',
    ListCommoditySpotPricesSummary: 'listCommoditySpotPricesSummary',
    ListCommodityWeeklyPricesSummary: 'listCommodityWeeklyPricesSummary',
    ListCommodityYearlyBalances: 'listCommodityYearlyBalances',
    ListDemeterSymbols: 'listDemeterSymbols',
    ListDemeterSymbolsWithExpiredContracts: 'listDemeterSymbolsWithExpiredContracts',
    ListDemeterTableDefinitions: 'listDemeterTableDefinitions',
    listDemeterTableDefinitionsCommodity: 'listDemeterTableDefinitionsCommodity',
    ListDemeterUsers: 'listDemeterUsers',
    ListDemeterUserPreferences: 'listDemeterUserPreferences',
    ListMarketIndicatorsCurrent: 'listMarketIndicatorsCurrent',
    ListMarketPriceVolatilities: 'listMarketPriceVolatilities',
    ListMarketPrices: 'listMarketPrices',
    ListMarketPricesComparisonChart: 'listMarketPricesComparisonChart',
    ListMarketPricesComparisons: 'listMarketPricesComparisons',
    ListMarketPricesForwardCurves: 'listMarketPricesForwardCurves',
    ListMarketPricesRolling: 'ListMarketPricesRolling',
    ListOtcPricesForwardCurves: 'listOtcPricesForwardCurves',
    ListProducerPriceIndex: 'ListProducerPriceIndex',
};
